import { useGetApiV1NotificationMobileAppSharedEnrollmentTypes } from '@/shared/api/generated/hooks/notificationMobileAppController/useGetApiV1NotificationMobileAppSharedEnrollmentTypes';

import type { NotificationEnrollmentStatus } from '../types/notification';

/**
 * Hook para buscar os tipos de status de matrícula disponíveis para filtragem de público.
 *
 * @returns Lista de status de matrícula com estado de loading
 *
 * @example
 * ```tsx
 * const { enrollmentStatuses, isLoading } = useEnrollmentStatuses();
 * ```
 */
export function useEnrollmentStatuses() {
  const { data = [], isLoading } = useGetApiV1NotificationMobileAppSharedEnrollmentTypes();

  const enrollmentStatuses: readonly NotificationEnrollmentStatus[] = data
    .filter(item => item.key !== undefined && item.value)
    .map(item => ({
      id: String(item.key),
      label: item.value as string,
    }));

  return { enrollmentStatuses, isLoading } as const;
}
